import { useContent } from "@/context/ContentContext";
import useMeta from "@/hooks/useMeta";
import { paragraphs } from "@/lib/api";
import { Reveal } from "@/components/site/Reveal";
import { Portrait } from "@/components/site/Portrait";
import { CtaBand } from "@/components/site/CtaBand";

export default function About() {
  const { content } = useContent();
  const a = content.about;
  useMeta(
    "About Violeta Dubov, Registered Social Worker",
    "Violeta Dubov is a Registered Social Worker (OCSWSSW #820913) based in Toronto, offering virtual psychotherapy across Ontario."
  );
  return (
    <>
      <section className="wrap grid gap-14 pb-16 pt-14 sm:pt-20 md:grid-cols-[0.85fr_1.15fr] md:gap-20">
        <div className="md:sticky md:top-28 md:self-start">
          <Reveal className="mx-auto w-full max-w-[360px]"><Portrait eager /></Reveal>
          <Reveal delay={150} className="mx-auto mt-10 max-w-[360px] rounded-2xl border border-[#6F5B9E]/30 bg-white p-6" data-testid="about-credentials-block">
            <p className="eyebrow mb-3">Credentials</p>
            <p className="font-display text-2xl leading-snug text-[#22304A]" data-testid="about-credentials-text">{a.credentials}</p>
            <p className="mt-3 text-sm leading-relaxed text-[#6B7280]">
              Regulated by the Ontario College of Social Workers and Social Service Workers (OCSWSSW).
            </p>
          </Reveal>
        </div>
        <div>
          <Reveal>
            <p className="eyebrow mb-5">About</p>
            <h1 className="text-4xl leading-[1.1] text-[#22304A] sm:text-5xl lg:text-6xl" data-testid="about-headline">{a.headline}</h1>
          </Reveal>
          <div className="mt-10 space-y-6" data-testid="about-bio">
            {paragraphs(a.bio).map((p, i) => (
              <Reveal as="p" key={i} delay={i * 60} className={i === 0 ? "font-display text-2xl text-[#22304A]" : "text-base leading-[1.85] text-[#22304A]/80 md:text-[17px]"}>
                {p}
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CtaBand title={content.home.final_cta_title} button={content.home.final_cta_button} />
    </>
  );
}
